import React, { useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Block from '../components/Block';
import { useSwipeable } from 'react-swipeable';
import CookiePopup from '../components/CookiePopup';
import '../style.css';

/**
 * Static models (no backend)
 */

interface TeamItem {
  id: number;
  name: string;
  position: string;
  text: string;
  imageUrl: string;
  position2?: string;
  number: number;
  bio?: string;
  expertise?: string[];
}

interface Testimonial {
  id: number;
  title: string;
  subtitle: string;
  name: string;
  company: string;
  text: string;
}

interface StaticTextModel {
  id?: number;
  topSubscribeTitle: string;
  topSubscribeText: string;
  scopeTitle: string;
  scopeText: string;
  testimonialsTitle: string;
  testimonialsText: string;
  teamTitle: string;
  teamText: string;
}

/**
 * UPDATED copy to match the screenshots
 */
const STATIC_TEAM: TeamItem[] = [
  {
    id: 4,
    name: "Chris Hearsey",
    position: "Founder & CEO",
    position2: "JD, MS",
    text: "",
    imageUrl: require("../assets/chris_hearsey.jpeg"),
    number: 1,
    bio: `Chris Hearsey is a seasoned expert in space law and policy, entrepreneurship, and executive leadership. With degrees in Mathematical Physics, Economics, Legal Theory, Space Studies, and a Juris Doctor with honors in Air and Space Law, he brings a comprehensive understanding of the space industry. Chris has held key C-suite roles, including CEO of Exolaunch US and Chief Strategy Officer at Rogue Space Systems Corporation, founding Outer Space Activities Consulting (OSA) in 2018 to help early-stage tech and space startups scale globally. Chris’s expertise includes strategic advising and planning, regulatory compliance, government affairs, and partnership development. He served as a Special Advisor at the U.S. State Department, contributed to significant space legislation, and co-founded the Space Court Foundation to promote space law education and the rule of law. With a track record of guiding commercial and non-profit companies through complex regulatory landscapes, Chris is dedicated to advancing innovation in the space community and technology sectors.`,
    expertise: [
      "Strategic Advising & Planning",
      "Corporate, Start-Up, and Nonprofit Management, Operations, and Compliance",
      "Space Law, Policy, and Economics",
      "Government Affairs & Partnership Development",
      "Transactions & Negotiations",
      "Go-To-Market Strategy",
    ],
  },
  {
    id: 5,
    name: "Jacqui Forte",
    position: "Executive Assistant",
    text: "",
    imageUrl: require("../assets/jackie_keys.jpeg"),
    number: 2,
    // Add a bio/expertise for Jacqui here when ready
  },
];

/**
 * UPDATED testimonial seed (single long quote like the design)
 */
const STATIC_TESTIMONIALS: Testimonial[] = [
  {
    id: 1,
    title: 'Mentorship that leveled up my business',
    subtitle: 'Strategy, ops, and executive communication',
    name: 'Gary Hlusko',
    company: 'Gridtech LLC (CEO)',
    text: `“Running a small software business entails wearing multiple hats, from providing technical support to managing operations. OSA has streamlined my business processes, identified opportunities, and offered insights into business development. Chris, in particular, has been an exceptional mentor, guiding me on effective communication strategies with C-Suite executives. Because of Chris's mentorship, I've not only navigated the complexities of startups and personal ventures but also strengthened my professional presence, contributing significantly to my company's growth.”`,
  },
  {
    id: 2,
    title: 'Global outreach that moves the needle',
    subtitle: 'Network facilitation & market access',
    name: 'Barton Bollfrass',
    company: 'Fathom Tanks',
    text: `“OSA has been instrumental in perfecting outreach and network facilitation for our water simulation tanks at Fathom. Their expertise and dedication have significantly enhanced our ability to connect with clients and stakeholders across the globe. With a diverse and highly skilled team, Chris brings a wealth of knowledge and experience in international business to the table, spanning multiple disciplines and industries. Their comprehensive approach to network facilitation has been invaluable in expanding our reach and establishing Fathom Tanks as a leader in our field.

The OSA team are truly a force to be reckoned with. Their commitment to excellence and their ability to navigate complex networks with ease make them an indispensable asset to any organization. I would highly recommend OSA Consulting to anyone seeking top-tier outreach and network facilitation services. Their professionalism, expertise, and results-driven approach set them apart in the industry, ensuring success for their clients.”`,
  },
  {
    id: 3,
    title: 'Contracting wins in a bespoke market',
    subtitle: 'Negotiation & strategic advisory',
    name: 'Thomas Reemer',
    company: 'Space Hero (CEO)',
    text: `“As the CEO of Space Hero, I have had the privilege of working closely with Chris Hearsey over the past five years. Throughout this time, Chris has consistently demonstrated an exceptional ability to negotiate advantageous contracts and provide strategic advice that significantly contributed to our company's success. His flexibility in adapting to changing circumstances, coupled with his unwavering diligence, has been instrumental in securing favorable contracts for Space Hero in a highly bespoke market.

Chris's business-focused approach is truly commendable. He possesses a keen understanding of the intersection between media and the space industry and leverages this knowledge to navigate complex negotiations with finesse. His insights and recommendations have been invaluable in guiding our strategic decision-making processes, enabling us to capitalize on emerging opportunities and mitigate potential risks effectively. Chris's dedication to delivering results that align with our business objectives is evident in every aspect of his work.

Chris Hearsey brings professionalism, adaptability, and an unwavering commitment to driving business success and makes him a highly valuable asset to any organization. I wholeheartedly recommend Chris to any company seeking a seasoned consultant who can deliver tangible results and strategic guidance with excellence.”`,
  },
  {
    id: 4,
    title: 'Regulatory navigation & signal amplification',
    subtitle: 'Compliance, storytelling, and connections',
    name: 'Deborah Sass',
    company: 'Space Verse (CEO & Founder)',
    text: `“Working with OSA has been a game-changer for us in the space industry. They've not only helped us navigate the tough terrain of regulations but also sharpened our pitch decks, making our voice heard in the space community.

Their dedication has opened doors we never thought possible, connecting us with industry leaders and opportunities we couldn't have accessed alone. Their practical strategies have kept us compliant and competitive in this fast-paced sector.

Chris Hearsey and the OSA team aren't just experts; they're genuinely invested in our success. Their down-to-earth approach has made every interaction valuable, and we're grateful for their support as we continue to grow in the space industry.”`,
  },
    {
      id: 5,
      title: "Strategy & Compliance That Accelerate Missions",
      subtitle: "Market assessment, licensing, and go-to-market",
      name: 'Jon Beam',
      company: "Rogue Space Systems",
      text: `Rogue Space Systems is an in-space logistics services company and space platform systems provider, and we are pleased to share about the level of space industry expertise and strategic acumen of OSA consulting. They led us through assessing the industry and market, which has led us to new opportunities and is positioning us as industry leaders.
  Chris's executive level expertise in government affairs and policy was helpful in getting our first mission into space. His guidance through the complex landscape of satellite licensing ensured our compliance and streamlined our operations, boosting our success. His industry acumen and knowledge have been invaluable to our progress as a company.
  We recommend OSA Consulting to any organization seeking top-tier consulting for strategy, operations, and compliance.`
    }
];

const STATIC_TEXTS: StaticTextModel = {
  // Hero
  topSubscribeTitle: "Tailor solutions. Innovate industries. Achieve horizons.",
  topSubscribeText:
    "We guide organizations through governance, strategy, and organizational design—built for complex, high-stakes domains like space, defense, and advanced technology.",

  // Our Scope
  scopeTitle: "Our Scope",
  scopeText:
    "Corporate governance, strategic development, and organizational design—delivered as focused projects or an integrated program to meet you where you are.",

  // Testimonials
  testimonialsTitle: "Testimonials",
  testimonialsText:
    "Thoughtful partners who deliver clarity and execution in complex environments.",

  // Team
  teamTitle: "Our Team",
  teamText:
    "Senior, hands-on operators and advisors. Explore our profiles and domain expertise.",
};

const Main: React.FC = () => {
  const [people] = useState<TeamItem[]>([...STATIC_TEAM]);
  const [testimonials] = useState<Testimonial[]>(STATIC_TESTIMONIALS);
  const [staticTexts] = useState<StaticTextModel>(STATIC_TEXTS);

  // UI state (carousel only)
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const handlePrevClick = () => {
    if (testimonials.length > 0) {
      setCurrentIndex((i) => (i - 1 + testimonials.length) % testimonials.length);
    }
  };

  const handleNextClick = () => {
    if (testimonials.length > 0) {
      setCurrentIndex((i) => (i + 1) % testimonials.length);
    }
  };


  const handlers = useSwipeable({
    onSwipedLeft: handleNextClick,
    onSwipedRight: handlePrevClick,
  });

  // pick the single bio person (first with a bio)
  const featured = people.find(p => p.bio);

  return (
    <div>
      <Header />
      <CookiePopup />
      <div className="main space-low">
        <div className="banner-container">
          <div className="container">
            <div className="content-wrapper">
              <div className="banner-image-container">
                {/* /HERO OVERLAY */}
                <div className="tags">
                  <div className="aerospace"></div>
                  <div className="energy"></div>
                  <div className="finteh"></div>
                  <div className="logistics"></div>
                  <div className="ngo"></div>
                  <div className="robotics"></div>
                  <div className="soft"></div>
                  <div className="telecom"></div>
                </div>
              </div>
            </div>

            {/* HERO COPY */}
            <div className="text-input-container">
              <div className="text-h2">
                <p style={{ display: staticTexts?.topSubscribeTitle ? "block" : "none" }}>
                  {staticTexts?.topSubscribeTitle}
                </p>
                <a style={{ display: staticTexts?.topSubscribeText ? "block" : "none" }}>
                  {staticTexts?.topSubscribeText}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="scope-container" id="scope">
          <div className="container">
            <div className="scope-title">
              <h1>{staticTexts?.scopeTitle}</h1>
              <p>{staticTexts?.scopeText}</p>
            </div>
            <div className="scope-image"></div>
          </div>
        </div>

        <div className="testimonials-container">
          <div className="container">
            <div className="testimonials-title">
              <h1>{staticTexts?.testimonialsTitle}</h1>
              <p>{staticTexts?.testimonialsText}</p>
            </div>

            <div {...handlers} className="testimonials-content">
              {testimonials.length > 0 ? (
                <>
                  <div className="testimonials-content-title">
                    <h1>{testimonials[currentIndex].title}</h1>
                    <p>{testimonials[currentIndex].subtitle}</p>
                  </div>
                  <div className="testimonials-content-post">
                    <div className="post-title">
                      <div className="post-title-text">
                        <h2 className="post-author">{testimonials[currentIndex].name}</h2>
                        <p className="post-company">{testimonials[currentIndex].company}</p>
                      </div>
                    </div>
                    <p className="testimonial-text">{testimonials[currentIndex].text}</p>
                  </div>
                  <div className="navigation">
                    <div className="indicators">
                      {testimonials.map((_, index) => (
                        <span
                          key={index}
                          className={`indicator ${currentIndex === index ? "active" : ""}`}
                          onClick={() => setCurrentIndex(index)}
                        ></span>
                      ))}
                    </div>
                    <div className="arrows">
                      <div className="arrow left" onClick={handlePrevClick}></div>
                      <div className="arrow right" onClick={handleNextClick}></div>
                    </div>
                  </div>
                </>
              ) : (
                <p>Loading...</p>
              )}
            </div>
          </div>
        </div>

        {/* ===== Featured Bio (its own section) ===== */}
        {featured && (
          <section className="featured-bio-container" id="bio">
            <div className="container">
              <div className="featured-bio">
                <div className="featured-bio__image">
                  <img src={featured.imageUrl} alt={featured.name} />
                </div>
                <div className="featured-bio__content">
                  <h1 className="featured-bio__name">{featured.name}</h1>
                  <p className="featured-bio__role">
                    {featured.position}{featured.position2 ? ` • ${featured.position2}` : ''}
                  </p>
                  {featured.bio && <p className="featured-bio__text">{featured.bio}</p>}
                  {featured.expertise?.length ? (
                    <>
                      <h4 className="featured-bio__expertise-title">Subject Matter Expertise</h4>
                      <ul className="featured-bio__expertise-list">
                        {featured.expertise.map((e, i) => <li key={i}>{e}</li>)}
                      </ul>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ===== Team Grid (no inline bios) ===== */}
        <div className="team-container" id="team">
          <div className="container">
            <div className="team-title">
              <h1>{staticTexts?.teamTitle}</h1>
              <p>{staticTexts?.teamText}</p>
            </div>

            <div className="team-people">
              {people
                .sort((a, b) => a.number - b.number)
                .map(item => (
                  <div className="team-card" key={item.id}>
                    <div className="team-card__image">
                      <img src={item.imageUrl} alt={item.name} />
                    </div>
                    <div className="team-card__footer">
                      <div className="team-card__meta">
                        <div className="team-card__name">{item.name}</div>
                        <div className="team-card__role">{item.position}</div>
                        {item.position2 && <div className="team-card__role-2">{item.position2}</div>}
                      </div>   
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Main;
